import type { ShouldRevalidateFunction } from "react-router";

const shouldRevalidate: ShouldRevalidateFunction = ({
  actionResult,
  defaultShouldRevalidate,
}) => {
  if (actionResult) return false;

  return defaultShouldRevalidate;
};

export default shouldRevalidate;
